import domReady from "@wordpress/dom-ready";

type Options = {
    classNameScrolled?: string;
};

const defaultOptions: Options = {
    classNameScrolled: 'is-scrolled',
};

class View {
    constructor(private options: Options = defaultOptions) {
        this.options = {
            ...defaultOptions,
            ...options,
        };

        this.init();
    }

    public init(): void {
        window.addEventListener('scroll', this.onScroll.bind(this));
        this.checkScroll();
    }

    public isScrolled(): boolean {
        return window.scrollY > 0;
    }

    public checkScroll(): void {
        if (this.isScrolled()) {
            document.body.classList.add(this.options.classNameScrolled);

            return;
        }

        document.body.classList.remove(this.options.classNameScrolled);
    }

    private async onScroll(event: Event): Promise<void> {
        this.checkScroll();
    }
}

domReady(() => {
    new View();
});
